import React from 'react';
import { GenericOption } from '../GenericOption/GenericOption';
import { StyledOptionalText } from './Checkbox.styles';
import { checkboxPropTypes } from './Checkbox.types';
export const Checkbox = React.forwardRef(function Checkbox(props, ref) {
    return (React.createElement(GenericOption, { ...props, type: "checkbox", ref: ref },
        props.children,
        ' ',
        !props.required && React.createElement(StyledOptionalText, null, "(optional)")));
});
Checkbox.propTypes = checkboxPropTypes;
//# sourceMappingURL=Checkbox.js.map